/**
 * Created by wl on 2017/3/16.
 */

export default {
    componentNamePrefix: 'v',
};



// WEBPACK FOOTER //
// ./vb/utils/config.js